import CoinCard from "../ui/card/coinCard";
import type { TokenDataType } from "@/utils/types";

export default function MemeCoinsSection({
  tokenData,
}: {
  tokenData: TokenDataType;
}) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {tokenData.tokens.map((coin) => (
        <CoinCard key={coin.token_address} coin={coin} />
      ))}
    </div>
  );
}
